import { render, staticRenderFns } from "./CreditDebit.vue?vue&type=template&id=673ae607&scoped=true"
import script from "./CreditDebit.vue?vue&type=script&lang=js"
export * from "./CreditDebit.vue?vue&type=script&lang=js"
import style0 from "./CreditDebit.vue?vue&type=style&index=0&id=673ae607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ae607",
  null
  
)

export default component.exports